'use strict';

import Vue from 'vue';
import JQueryUI from 'jquery-ui-dist/jquery-ui.js';
import Select2 from 'select2';
import CodeMirror from 'codemirror';
import EasyMDE from 'easymde';
import Dropzone from 'dropzone';
import Moment from 'moment';
import Jsyaml from 'js-yaml';
import * as Vuetable from 'vuetable-2';
import FeaturePermissionCheck from './mixins/FeaturePermissionCheck';

import Bootstrap from 'bootstrap';
import Nestable from 'nestable2';
import JQueryConfirm from 'jquery-confirm';
import Chart from 'chart.js';
import Datatables from 'datatables.net';
import DatatablesBS4 from 'datatables.net-bs4';
import Flatpickr from 'flatpickr';
import MomentTimezone from 'moment-timezone';
import Typeahead from 'typeahead.js';
import Bloodhound from 'typeahead.js';
// import Summernote from 'summernote';

import 'codemirror/lib/codemirror.js';
import 'codemirror/addon/mode/overlay.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/edit/closebrackets.js';
import 'codemirror/addon/edit/matchtags.js';
import 'codemirror/addon/edit/closetag.js';
import 'codemirror/addon/lint/javascript-lint.js';
import 'codemirror/addon/mode/overlay.js';
import 'codemirror/addon/hint/show-hint.js';
import 'codemirror/addon/hint/css-hint.js';
import 'codemirror/addon/hint/javascript-hint.js';
import 'codemirror/addon/fold/xml-fold.js';
import 'codemirror/mode/xml/xml.js';
import 'codemirror/mode/twig/twig.js';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/addon/lint/lint.js';
import 'codemirror/addon/display/autorefresh.js';
import {JSHINT} from 'jshint';

import 'ASSETS_ROOT/javascript/summernote.js';
import 'ASSETS_ROOT/javascript/selection.js';
import 'ASSETS_ROOT/javascript/local.js';
import 'ASSETS_ROOT/javascript/tagselector.jquery.js';
import 'ASSETS_ROOT/javascript/batch.js';
import 'ASSETS_ROOT/javascript/ajax-listener.js';
import 'ASSETS_ROOT/stylesheets/app.scss';

// window.$ = window.jQuery = require('jquery');
window.Vue = Vue;
window.CodeMirror = CodeMirror;
window.EasyMDE = EasyMDE;
window.Dropzone = Dropzone;
window.Flatpickr = Flatpickr;
window.Moment = Moment;
window.Jsyaml = Jsyaml;
window.jsonlint = 'codemirror/addon/lint/json-lint.js';
window.JSHINT = JSHINT;
window.baseURL = window.location.protocol + "//" + window.location.host;

Vue.use(Vuetable);
Vue.mixin(FeaturePermissionCheck);
